/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Back_HomeInputs */

const en_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const de_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurueck zur Startseite`)
};

const fr_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

const es_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

const it_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla home`)
};

const nl_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar startpagina`)
};

const pl_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót na stronę główną`)
};

const fi_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin etusivulle`)
};

const da_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til forsiden`)
};

const sv_impressum_back_home = /** @type {(inputs: Impressum_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till startsidan`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Impressum_Back_HomeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_back_home = /** @type {((inputs?: Impressum_Back_HomeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Back_HomeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_back_home(inputs)
	if (locale === "fr") return fr_impressum_back_home(inputs)
	if (locale === "es") return es_impressum_back_home(inputs)
	if (locale === "it") return it_impressum_back_home(inputs)
	if (locale === "nl") return nl_impressum_back_home(inputs)
	if (locale === "pl") return pl_impressum_back_home(inputs)
	if (locale === "fi") return fi_impressum_back_home(inputs)
	if (locale === "da") return da_impressum_back_home(inputs)
	if (locale === "sv") return sv_impressum_back_home(inputs)
	return en_impressum_back_home(inputs)
});